module.exports = __webpack_public_path__ + "static/rocket-to-phone-white-0062e23c651f01a04abe9ec1315b2566.gif";